import { createSlice, createSelector } from '@reduxjs/toolkit';
import { SessionStateType } from '@business/entities/session';
import type { RootState } from './store';

const initialState: SessionStateType = {
  isAdmin: false,
  userPermissions: [],
  notificationType: false,
  subscriberId: null,
  page: null,
  notificationData: null,
  isMediaUploadModalOpen: false
};

export const sessionStateSlice = createSlice({
  name: 'sessionStateSlice',
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    resetSessionState: () => {
      return initialState;
    },
    setSubscriberId: (state, action) => {
      state.subscriberId = action.payload.subscriberId;
    },
    setIsMediaUploadModalOpen: (state, action) => {
      state.isMediaUploadModalOpen = action.payload;
    },
    logoutUser: state => {
      state.isAdmin = false;
      state.token = null;
      state.refreshToken = null;
      state.userPermissions = [];
    },
    setUserNotificationData: (state, action) => {
      state.page = action.payload.page;
      state.notificationData = action.payload.notificationData;
    }
  }
});

export const {
  setToken,
  resetSessionState,
  logoutUser,
  setSubscriberId,
  setUserNotificationData,
  setIsMediaUploadModalOpen
} = sessionStateSlice.actions;
export const getToken = (state: RootState) => state.sessionStateSlice?.token;
export const getRefreshToken = (state: RootState) =>
  state.sessionStateSlice?.refreshToken;
export const getSubscriberId = (state: RootState) =>
  state.sessionStateSlice?.subscriberId;
export const getIsMediaUploadModalOpen = (state: RootState) =>
  state.sessionStateSlice?.isMediaUploadModalOpen;
export const getUserNotificationData = createSelector(
  [
    (state: RootState) => state.sessionStateSlice?.page,
    (state: RootState) => state.sessionStateSlice?.notificationData
  ],
  (page, notificationData) => ({
    page,
    notificationData
  })
);
